/**
 * FinanceApp - Copyright (c) 2026 Emmanuel TESTE
 * Tous droits réservés - Logiciel propriétaire
 */
import { createContext, useContext, useState, useEffect } from 'react';
import { THEMES } from '../styles/themes';

const ThemeContext = createContext({ theme: 'light', toggle: () => {} });

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem('financeapp_theme');
    if (saved === 'light' || saved === 'dark') return saved;
    // Le clair est le choix professionnel par défaut (décision produit),
    // volontairement indépendant de la préférence système de l'appareil —
    // sinon un visiteur en navigation privée (ou tout simplement dont l'OS
    // est en mode sombre) atterrirait en sombre/indigo sans jamais l'avoir choisi.
    return 'light';
  });

  useEffect(() => {
    const vars = THEMES[theme];
    const root = document.documentElement;
    Object.entries(vars).forEach(([k, v]) => root.style.setProperty(k, v));
    document.body.setAttribute('data-theme', theme);
    localStorage.setItem('financeapp_theme', theme);
  }, [theme]);

  const toggle = () => setTheme(t => t === 'dark' ? 'light' : 'dark');

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
